<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/settings">الإعدادات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <SettingsForm v-if="!mainLoading && checkAccess('settings_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :typeChioces="typeChioces"
              :settingsKeys="settingsKeys"
            />
            <SettingsView v-if="!mainLoading && !checkAccess('settings_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :typeChioces="typeChioces"
              :settingsKeys="settingsKeys"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import SettingsForm from './form.vue';
import SettingsView from './view.vue';

export default {
  name: 'SettingsUpdate',
  components: {
    SettingsForm, SettingsView
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل الإعداد ',
      row: null,
      typeChioces: {},
      settingsKeys: {},
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/settings/retrieve/${this.id}`).then(({data}) => {
        this.rowTitle = this.rowTitle + data.settingsKeys[data.row.key];
        this.row = data.row;
        this.typeChioces = data.typeChioces;
        this.settingsKeys = data.settingsKeys;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>
